export const getStyles = () => {
    const styles = {
        mb: 1,
        "& .ql-editor": {
            minHeight: "140px",
        },
    };
    return styles;
};